import type { ReactNode } from 'react'
import { PageContainer } from '@ant-design/pro-components'

export function OrderListContainer({
  compact,
  title,
  content,
  children
}: {
  compact: boolean
  title: string
  content: string
  children: ReactNode
}) {
  return compact ? (
    <div className="p-3 sm:p-4">{children}</div>
  ) : (
    <PageContainer breadcrumbRender={false} title={title} content={content}>
      {children}
    </PageContainer>
  )
}
